module.exports = __webpack_public_path__ + "img/icon-google.e05c9b3d.svg";